import clsx from 'clsx';
import type * as React from 'react';

/**
 * Wrap the content of a block.
 * https://user-images.githubusercontent.com/8937991/236822645-feac21e1-76e0-40d0-bd94-013452187d8c.png
 */
export function BlockWidthWrapper({ className, ...rest }: React.ComponentProps<'div'>) {
    return (
        <div
            className={clsx(
                'relative mx-auto page-block-openapi:ml-0 page-full-width:ml-0 w-full',
                className
            )}
            {...rest}
        />
    );
}
